// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { UpdateSupportStatus } from '../../../apis/base';
import { RootAction, actionCreatorsList } from '../../rootActionCreator';
const { updateSupportStatusActions } = actionCreatorsList;

const outputActions = {
  success: updateSupportStatusActions.success,
  failure: updateSupportStatusActions.failure
};

type RequestActionTypes = ActionType<typeof updateSupportStatusActions.request>;
type OutputActionTypes = ActionType<typeof outputActions>;

const updateSupportStatusEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      getType(updateSupportStatusActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      const { id }= action.payload
      return UpdateSupportStatus(id)
        .then(response => {
          return outputActions.success({ ...response.data })
        })
        .catch((error: AxiosError) => {
          console.log(error)
          return outputActions.failure({ error });
        });
    })
  );
};

export { updateSupportStatusEpic as default };

